<script>
    export let image;
    export let name;
</script>

<div class="row patron-container">
    <div class="patron-details">
        <img src={image} alt={name ?? "logo"} />
    </div>
</div>

<style>
    .patron-container {
        box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 1.565rem 1.875rem;
        position: relative;
        height: 300px;
        max-width: 80vw;
        margin-top: 3.75rem;
    }

    .patron-details {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        max-height: 100%;

    }

    .patron-details img {
        max-width: 100%;
        max-height: 100%;
    }

    @media (max-width: 768px) {
        .patron-container {
            width: 85vw;
            padding: 1rem;
        }
    }
</style>
